import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";
import { ProductCard } from "../components/ProductCard";
import { ConnectState } from "../components/ConnectState";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";

export default function CollectionDetail() {
  const { handle } = useParams();
  const [state, setState] = useState({ loading: true, connected: true, collection: null });

  useEffect(() => {
    setState({ loading: true, connected: true, collection: null });
    api
      .get(`/collections/${handle}`)
      .then((r) =>
        setState({ loading: false, connected: r.data.connected, collection: r.data.collection })
      )
      .catch(() => setState({ loading: false, connected: true, collection: null }));
  }, [handle]);

  const col = state.collection;

  return (
    <div>
      <PageHeader
        eyebrow="Collection"
        title={col?.title || handle.replace(/-/g, " ")}
        description={col?.description || undefined}
      />
      <div className="px-5 py-12 sm:px-10 lg:px-16">
        {state.loading ? (
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] animate-pulse bg-secondary" />
            ))}
          </div>
        ) : !state.connected ? (
          <Reveal>
            <ConnectState />
          </Reveal>
        ) : !col ? (
          <p className="border border-border p-16 text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
            Collection not found
          </p>
        ) : col.products.length === 0 ? (
          <p className="border border-border p-16 text-center font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">
            This collection is empty — add products in Shopify
          </p>
        ) : (
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
            {col.products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i % 8} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
